// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"373":"729a539b","483":"f2050046"}[chunkId] + ".chunk.js";
};